import './modules/language-switcher';
import './modules/sliders';
import './modules/offer-slider';
import './modules/login-register';
import './modules/featured-products';
import './modules/accordion';
import './modules/homepage-services';
import './modules/script';
import './modules/add-no-scroll-to-body';
import './modules/map/gmap';
import './modules/animations/homepage-animations';
import './modules/toggle-product-cats';
